// extracted by mini-css-extract-plugin
module.exports = {"container":"xUxDJOwNwYEjORYs7GhRW","icon":"_3PgayUq-pPxkiyvZ9usKf2"};